import React from 'react'
import { useSelector } from 'react-redux';

export default function BidValue({ symbolId, digits, newOrder = false }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    return <span style={{...(newOrder && { color: "#fff" })}} className={`${symbol?.bidColor == 'down' && 'red'} ${symbol?.bidColor == 'up' && 'green'} `}>{symbol?.bid ? symbol?.bid?.toFixed(digits || symbol.digits) : '0.00'}</span>;

}
